import storeConfigQuery from '~layers/app/graphql/storeConfig.gql'
import type { MagentoCountry } from '~layers/app/types/magento.d.ts'

export function useStore() {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
  const storeData = useState<any>('storeData', () => null)

  async function fetchStoreData() {
    if (!storeData.value) {
      const { data } = await useAsyncQuery(storeConfigQuery, undefined, 'customer')

      if (!data.value) {
        return
      }

      storeData.value = data.value
    }
  }

  const storeConfig = computed(() => storeData.value?.storeConfig)
  const countries = computed(() => storeData.value?.countries || [])

  const getCountry = (countryCode: string): MagentoCountry | null => countries.value.find(item => item.code === countryCode) || null
  const regions = (countryCode: string) => countries.value?.find(item => item.code === countryCode)?.regions || []
  const regionId = (countryCode: string, regionCode: string) => regions(countryCode).find(item => item.code === regionCode)?.id || null

  return {
    regionId,
    regions,
    storeConfig,
    countries,
    getCountry,
    fetchStoreData,
  }
}
